import React, { Component } from 'react';
// import logo from "../assets/logo_espol_blanco.svg";
import logo from "../assets/logo_espol_interno.svg";

import "../css/CambiarContrasenia.css"
import FormCambiarContrasenia from './components/FormCambiarContrasenia.js';
import axios from 'axios';
import {Alert} from 'react-bootstrap';
import Modal from './components/Modal.js';
import equis from "../assets/eliminar.svg";
import info from "../assets/Info.png";
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import CenteredWrapper from './components/CenteredWrapper.js';



export class CambiarContraseniaRedirect extends Component {

    constructor(props){
        super(props);

        this.state={
            btnSiguiente:false,
            loading: false,
            activebutton: true,
            datosUsuario:{
                identificacion: "",
            },
			modal:{
                show:false,
                titulo:"",
                mensaje:"",
                imagen:""
            },
            modalMessage: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
            errorDatosUsuario: {
            },
            expresiones:{
                cedula: /^[a-zA-Z0-9._]{4,10}$/,
                correo:/^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}([/.]\w{2,})?$/,
            },
            errorSolicitud:{
                correo:"",
                password:"",
            },
        };
        
		this.abrirModal=this.abrirModal.bind(this);
        this.cerrarModal=this.cerrarModal.bind(this);
        this.cerrarModalError=this.cerrarModalError.bind(this);

    }

    componentWillMount() {
        this.useEffect();
    }

    useEffect = () => {
                const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        }
        //console.log(`${process.env.REACT_APP_CAPTCHAKEY}`);
        // load the script by passing the URL
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHAKEY}`, function () {
            //console.log("Script loaded!");
        });
    };


    setonloading() {
        this.setState({ loading: true });
    }


    setoffloading() {
        this.setState({ loading: false });
    }

	
	abrirModal(){
        this.setState({
            modal:{
                ...this.state.modal,
                show:true
            }
        });
    }

    cerrarModal(){
        this.setState({
            modal:{
                titulo:"",
                mensaje:"",
                imagen:"",
                show:false
            }
        });
        //console.log("cerrar modal "+this.state.modal);
    }

    cerrarModalError() {
        this.setState({
            modalMessage: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalMessage);
    }


    handlerOnBlurIdentificacion = async () => {

        if (!this.state.expresiones.cedula.test(this.state.datosUsuario.identificacion)) {
            await this.setState({
                errorDatosUsuario: {
                    ...this.state.errorDatosUsuario,
                    identificacion: "Identificacion debe tener al menos 4 caracteres"
                }
            })
        } else {
            this.setState({
                errorDatosUsuario: {
                    ...this.state.errorDatosUsuario,
                    identificacion: ""
                }
            })
        }
    }

    handlerDatosIndetificacion = async (e) => {
        await this.setState({
            datosUsuario: {
                ...this.state.datosUsuario,
            [e.target.name]: e.target.value.toLowerCase(),
            }
        })
        //console.log(this.state.datosUsuario);

        this.handlerOnBlurIdentificacion();
        // this.handleCorreIngresado();
    }

    postOlvidoContraApiExt = async (data) => {
        try {
            const resp = await axios.post(`${process.env.REACT_APP_API_EXT}/Account/OlvidoContrasenia`, data);

            if (resp.data?.status?.isSuccessfully) {
                // console.log(resp.data);
                sessionStorage.setItem("ccex", "1");
                window.location.href = '/cambiarcontrasenia';
            } else {
                let messageOlvidoContrasenia = resp.data.status.messages[0];

                if (typeof messageOlvidoContrasenia === 'string' && messageOlvidoContrasenia !== null) {
                    if (messageOlvidoContrasenia.includes("No existe una cuenta externa creada con ese correo electrónico")) {
                        this.setState({
                            modalMessage: {
                                show: true,
                                titulo: "ATENCIÓN",
                                mensaje: (
                                    <span className='olvContra-mdl-text' align="justify">
                                    No existe una cuenta externa creada con ese correo electrónico, ingrese aquí para registrarse:{" "}
                                    <a href="/registro"><i>Crear Cuenta</i></a>
                                    </span>
                                ),
                                imagen: info,
                            }
                        });
                    } else if (messageOlvidoContrasenia.includes("")) {
                        this.setState({
                                modalMessage: {
                                show: true,
                                titulo: "Error",
                                mensaje: "",
                                imagen: info,
                            }
                        });
                    } else {
                        this.setState({
                            modalMessage: {
                                show: true,
                                titulo: "Error",
                                mensaje: messageOlvidoContrasenia,
                                imagen: equis,
                            }
                        });
                    }
                } else {
                    this.setState({
                        modalMessage: {
                            show: true,
                            titulo: "Error",
                            mensaje: "Lo sentimos, tuvimos un problema.",
                            imagen: equis,
                        }
                    });
                }
            }
        } catch (error) {
            //console.log(error);
            this.setState({
            modal: {
                show: true,
                titulo: "Error",
                mensaje: "Lo sentimos, vuelva a intentar.",
                imagen: equis,
            }
            });
        }
    };

    renderFormOlvidoContra = async (e) => {
        this.setonloading();
        this.setState({ activebutton: false });

        e.preventDefault();

        var olvidarContrasenia = {
            identificacion: this.state.datosUsuario.identificacion,
        }

        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
            //console.log(token);
            axios.post(`${process.env.REACT_APP_API}api/Persona/cuenta`, olvidarContrasenia,{
                      headers: {
                        'X-Recaptcha-Token': token
                      }
                    })
                    .then(async (resp) => {
                        if (resp.data.success) {
                            let correoAlterno_temp = resp.data.persona.correoalterno;
                            if (correoAlterno_temp === "0" || correoAlterno_temp === "") {
                                this.setState({
                                    modal: {
                                        show: true,
                                        titulo: "Error en la solicitud",
                                        mensaje: <span className='olvContra-mdl-text' align="justify">En caso de NO tener actualizado el correo alterno o los datos presentados son incorrectos, puede comunicarse de lunes a viernes de 8h00 a 16h00 al teléfono (+593) 42269256 o escribir al siguiente correo:
                                            <a href="mailto:gerenciatecnologia@espol.edu.ec?" ><i>gerenciatecnologia@espol.edu.ec</i></a>
                                        </span>,
                                        imagen: equis
                                    }
                                });
                            } else {
                                // aqui es el redirect hacia microfost
                                // En tu componente donde determinas si es externo o no
                                sessionStorage.setItem("ccex", "0");
                                window.location.href = '/cambiarcontrasenia';
                                this.setState({ verModalOlvidoContra: true });
                                
                            }
                        } else {
                            //console.log("no entra");
                            await this.postOlvidoContraApiExt(olvidarContrasenia); 
                        }
                        //console.log("fuera");
                        this.setoffloading();
                        this.setState({ activebutton: true });


                    }).catch(async (error) => {
                        let messageError = error.response.data.errorMessage;
                        //console.log(messageError);

                        if (typeof messageError === 'string' && messageError !== null) {
                            if (messageError.includes("No se encontro persona con esa cedula")) {
                                await this.postOlvidoContraApiExt(olvidarContrasenia);
                            } else {
                                this.setState({
                                    modal: {
                                    show: true,
                                    titulo: "Error en la solicitud",
                                    mensaje: messageError,
                                    imagen: equis,
                                    }
                                });
                            }
                        }                        
                        this.setoffloading();
                        this.setState({ activebutton: true });
                    });
            });
        });
    }
    
    render() {

        return (

            <div >
                <Header />
                <CenteredWrapper>
                    <div className="cmbContra-container" >
                        <div className="cmbContra-container-btn" >
                            <div className="col-xl-4">

                            </div>
                            <div className="col-12 col-lg-8 col-xl-4 title_olvido_contra">
                                <p className="cmbContra-title"><b>CAMBIO DE CONTRASEÑA</b></p>
                            </div>
                            <div className="col-xl-4">
                            </div>
                        </div>
                        <div className="cmbContra-container-btn">
                            <div className="col-xl-4">

                            </div>
                            <div className="col-10 col-lg-8 col-xl-4">
                                <div className="row">
                                    <label htmlFor="identificacion" className="form-label">Número de Identificación:</label>
                                    <input
                                        className={this.state.errorDatosUsuario.identificacion ? "form-control cmbContra-input-error" : "form-control"}
                                        id="identificacion"
                                        placeholder="Número de doc. de Identidad"
                                        name="identificacion"
                                        value={this.state.datosUsuario.identificacion}
                                        onChange={this.handlerDatosIndetificacion}
                                        onBlur={this.handlerOnBlurIdentificacion} />

                                    {this.state.errorDatosUsuario.identificacion &&
                                        <p className='cmbContra-leyenda'>{this.state.errorDatosUsuario.identificacion}</p>
                                    }
                                </div>



                                <div className="row mt-4" align="center">
                                    <div className="col-xl-12" >
                                        <button
                                            type="submit"
                                            disabled={this.state.datosUsuario.identificacion &&
                                                !this.state.errorDatosUsuario.identificacion && this.state.activebutton ? false : true}
                                            className={this.state.datosUsuario.identificacion &&
                                                !this.state.errorDatosUsuario.identificacion && this.state.activebutton ?
                                                "btn-verificar-cmbContra" : "btn-verificar-cmbContra-disabled"}
                                            onClick={this.renderFormOlvidoContra}>
                                            SEGUIR
                                        </button>
                                        {!this.state.activebutton ?
                                            <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                            : null}
                                    </div>

                                </div>

                            </div>

                            <div className="col-xl-4">
                            </div>
                        </div>
                    </div>
                </CenteredWrapper>
                <Footer />

                {this.state.modal.show &&
                    <Modal isOpen={this.state.modal.show} cerrarModal={this.cerrarModal} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>{this.state.modal.titulo}</strong></p>
                        <div className='mt-3 mb-3' align="center">
                            <img className="cmbContra-mdl-img" src={this.state.modal.imagen} alt="Error"></img>
                        </div>

                        <p className='text-center'>{this.state.modal.mensaje}</p>


                    </Modal>
                }
                {this.state.modalMessage.show &&
                    <Modal isOpen={this.state.modalMessage.show} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>{this.state.modalMessage.titulo}</strong></p>
                        <div className='mt-3 mb-3' align="center">
                            <img className="cmbContra-check" src={this.state.modalMessage.imagen} alt="Exitoso"></img>
                        </div>

                        <p className='text-center'>{this.state.modalMessage.mensaje}</p>
                    </Modal>}


            </div>
            
            
        )
    }
}

export default CambiarContraseniaRedirect
